import { FC, ReactNode }     from 'react';
import { Link as ReactLink } from 'react-router-dom';
import Style                 from './Link.style';
import { linkHandler }       from 'Utils';
import { IArguments }        from '../../../Config/Routes';

type TProps = {
  to?: string,
  href?: string,
  externalLink?: string,
  args?: IArguments,
  children?: ReactNode,
  className?: string,
  onClick?: (evt: any) => void
}
export const Link: FC<TProps> = ({ to, href, externalLink, args, children, ...props }) => {

  let link = null;

  switch(true){
    case !!to:           link = <ReactLink { ...props } to={ to }>{ children }</ReactLink>; break;
    case !!href:         link = <ReactLink { ...props } to={linkHandler.get(href, args)}>{ children }</ReactLink>; break;
    case !!externalLink: link = <a href={`${externalLink} `} rel="noopener noreferrer" target="_blank">{children}</a>; break;
  }

  return(
    <Style { ...props }>
      { link }
    </Style>
  );
}
